module.exports = __webpack_public_path__ + "static/media/VeteransActive.a5737c20.svg";